import AmioHttpService from '@/services/amio/amio-http.service'

class IndexSourcesService extends AmioHttpService {

  async create(indexId, payload) {
    try {
      const response = await this.requestPost(`/indexes/${indexId}/sources`, payload)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async update(indexId, indexSourceId, patchData) {
    try {
      const response = await this.requestPatch(`/indexes/${indexId}/sources/${indexSourceId}`, patchData)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async delete(indexId, indexSourceId) {
    try {
      await this.requestDelete(`/indexes/${indexId}/sources/${indexSourceId}`)
    } catch (err) {
      throw this.handleError(err)
    }
  }

}

export default new IndexSourcesService()
